import CubemapSeamDetector from './detector';



let isSeamlessResolve;

const isSeamless = new Promise((resolve, reject) => {
    isSeamlessResolve = resolve;
});

let cubemapSeamDetector = new CubemapSeamDetector();

function checkSeamless(renderer) {
    cubemapSeamDetector.waitImageLoad().then(() => {
        try {
            cubemapSeamDetector.initRender();
            const seamless = cubemapSeamDetector.renderAndCheckSeamless(renderer);
            isSeamlessResolve(seamless);
        } catch (error) {
            isSeamlessResolve(true);
        }
    }, () => isSeamlessResolve(true));
}

export { checkSeamless, isSeamless };
